export default __webpack_public_path__ + "static/media/rh4000.10ddc8e8.svg";